import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@/react/components/shared/TippyV2";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-uikit/Button";
import { useBuilderStore } from "../Hooks/useBuilderStore";

export const CanvasZoomStepper = ({ className }: { className?: string }) => {
  const { level, minLevel, maxLevel, zoomIn, zoomOut } = useBuilderStore(
    state => state.zoom,
  );

  const formattedZoomLevel = `${(level * 100).toFixed(0)}%`;

  return (
    <div
      className={classNames(
        "bg-primary flex items-center gap-1 rounded-xl p-1",
        className,
      )}
    >
      <TippyV2
        content={t("builder_ui.canvas.zoom.out")}
        placement="top"
        delay={100}
        duration={100}
        arrow={false}
      >
        <Button
          onClick={zoomOut}
          variant="tertiary"
          small
          isFullRounded={false}
          className="!rounded-lg !p-1.5"
          disabled={level <= minLevel}
          type="button"
        >
          <Icon
            type="20-minus"
            size={20}
            aria-label={t("builder_ui.canvas.zoom.out")}
          />
        </Button>
      </TippyV2>
      <span className="w-9 text-center text-sm font-semibold">
        {formattedZoomLevel}
      </span>
      <TippyV2
        content={t("builder_ui.canvas.zoom.in")}
        placement="top"
        delay={100}
        duration={100}
        arrow={false}
      >
        <Button
          onClick={zoomIn}
          variant="tertiary"
          small
          isFullRounded={false}
          className="!rounded-lg !p-1.5"
          disabled={level >= maxLevel}
          type="button"
        >
          <Icon
            type="20-plus-v3"
            size={20}
            aria-label={t("builder_ui.canvas.zoom.in")}
          />
        </Button>
      </TippyV2>
    </div>
  );
};
